import GameState from "../state/gameState";
import Phaser from "phaser";

import { GameEvents, BOARD_SIZE, layerDepthDiff } from "../constants";
import BaseEntity from "./BaseEntity";
import data from "../artConfig.json";
import { Dir } from "./Player";

let anim;

// References for using sprites.
// From example: https://phaser.io/examples/v3/view/game-objects/particle-emitter/custom-particles
// From post: https://www.html5gamedevs.com/topic/38970-particles-emitter-how-to-use-sprites-from-a-spriteatlas/

// This is the FX for the lazor basically.
export default class PlayerBullet extends BaseEntity {
  private lazorPool: any;
  constructor(gameState: GameState, scene: Phaser.Scene) {
    super(gameState, scene);

    this.lazorPool = this.scene.add.group({
      defaultKey: "shoot_fx",
      maxSize: 100,
    });

    scene.events.on(GameEvents.PlayerShot, this.triggerLazorFx, this);
  }

  addLazorSprite(
    x: number,
    y: number,
    isFacingUp: boolean = false
  ): Phaser.GameObjects.Sprite | null {
    const lazor: Phaser.GameObjects.Sprite = this.lazorPool.get(x, y);
    if (!lazor) {
      return null;
    }
    lazor.setFlipX(false);
    lazor.setFlipY(false);
    lazor.originX = 0.5;
    lazor.originY = 0.5;
    lazor.x = x * BOARD_SIZE;
    lazor.y = y * BOARD_SIZE;
    lazor.setRotation(0);
    if (isFacingUp) {
      lazor.x += BOARD_SIZE;
      lazor.setRotation(Math.PI / 2);
    } else {
      if (Math.random() < 0.5) {
        lazor.setFlipX(true);
        lazor.x += BOARD_SIZE;
      }
    }
    lazor.setDepth(y + layerDepthDiff.BOXES);

    lazor.setActive(true).setVisible(true).play(data.animations.shoot_fx.key);
    lazor.once("animationcomplete", () => {
      this.lazorPool?.killAndHide(lazor);
    });
    return lazor;
  }

  addLazorSpriteKink(x: number, y: number, dir: Dir, endDir: Dir) {
    const lazor: Phaser.GameObjects.Sprite = this.lazorPool.get(x, y);
    if (!lazor) {
      return null;
    }
    lazor.setFlipX(false);

    lazor.originX = 0.5;
    lazor.originY = 0.5;
    lazor.x = x * BOARD_SIZE;
    lazor.y = y * BOARD_SIZE;
    lazor.setRotation(0);

    lazor.setDepth(y + layerDepthDiff.BOXES + 0.01);

    if (dir === Dir.Down || endDir === Dir.Up) {
      lazor.setFlipY(false);
      lazor.setDepth(y + layerDepthDiff.BOXES - 0.01);
    } else {
      lazor.setFlipY(true);
      lazor.y += BOARD_SIZE;
    }
    if (dir === Dir.Right || endDir === Dir.Left) {
      lazor.setFlipX(false);
    } else {
      lazor.setFlipX(true);
      lazor.x += BOARD_SIZE;
    }

    lazor
      .setActive(true)
      .setVisible(true)
      .play(data.animations.shoot_fx_corner.key);
    lazor.once("animationcomplete", () => {
      this.lazorPool?.killAndHide(lazor);
    });
  }

  triggerLazorFx({
    x,
    y,
    x2,
    y2,
    dir,
    endDir,
  }: {
    x: number;
    y: number;
    x2: number;
    y2: number;
    dir: Dir;
    endDir: Dir;
  }) {
    const xMin = Math.min(x, x2);
    const xMax = Math.max(x, x2);
    const yMin = Math.min(y, y2);
    const yMax = Math.max(y, y2);
    if (dir === endDir) {
      if ([Dir.Right, Dir.Left].includes(dir)) {
        for (let x3 = xMin; x3 <= xMax; x3++) {
          const lazor = this.addLazorSprite(x3, y, false);
        }
      } else {
        for (let y3 = yMin; y3 <= yMax; y3++) {
          this.addLazorSprite(x, y3, true);
        }
      }
    } else {
      if ([Dir.Right, Dir.Left].includes(dir)) {
        for (let x3 = xMin; x3 <= xMax; x3++) {
          if (dir === Dir.Right && x3 === xMax) {
            this.addLazorSpriteKink(x3, y, dir, endDir);
          } else if (dir === Dir.Left && x3 === xMin) {
            this.addLazorSpriteKink(x3, y, dir, endDir);
          } else {
            this.addLazorSprite(x3, y, false);
          }
        }
      } else {
        for (let y3 = yMin; y3 <= yMax; y3++) {
          if (dir === Dir.Down && y3 === yMax) {
            this.addLazorSpriteKink(x, y3, dir, endDir);
          } else if (dir === Dir.Up && y3 === yMin) {
            this.addLazorSpriteKink(x, y3, dir, endDir);
          } else {
            this.addLazorSprite(x, y3, true);
          }
        }
      }
    }
  }
}
